// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1tdYW","toggle":"styles_toggle__2LPOD","preview":"styles_preview__18nD7"};